<div class="gridLayout">
    <div class="container">
        <div class="actionItems" *ngIf="selection.selected.length">
            <div class="selectedItemsCount">
                <span>{{ selection.selected.length }} Selected</span>
            </div>
            <div class="actionBtn" (click)="openEditQuantityDialog()">
                <img src="assets/icons/edit_24px.svg" />
                <span class="editQuantity">Edit Quantity</span>
            </div>
            <div class="actionBtn" (click)="deleteVariants()">
                <img src="assets/icons/delete_24px.svg" />
                <span class="remove">Remove</span>
            </div>
        </div>
        <div class="table-content">
            <table
                mat-table
                [dataSource]="matTableDataSource"
                class="mat-elevation-z8"
            >
                <ng-container matColumnDef="select" class="check">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox
                            [disabled]="
                                displayedColumns1.length == 3 ||
                                !isColorAndSizeLabelsAvailable()
                            "
                            (change)="$event ? masterToggle() : null"
                            [checked]="
                                selection.hasValue() &&
                                isAllSelected() &&
                                displayedColumns1.length == 4
                            "
                            [indeterminate]="
                                selection.hasValue() && !isAllSelected()
                            "
                            [aria-label]="checkboxLabel()"
                        >
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox
                            [disabled]="
                                displayedColumns1.length == 3 ||
                                !(row.colorLabel && row.sizeLabel)
                            "
                            (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            color="primary"
                        >
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="variant">
                    <th mat-header-cell *matHeaderCellDef>Set Variants</th>
                    <td mat-cell *matCellDef="let el; index as i">
                        <span *ngIf="!el.colorLabel && !el.sizeLabel">{{
                            '--'
                        }}</span>
                        <span *ngIf="el.colorLabel && el.sizeLabel">{{
                            (el.colorLabel || '-') +
                                ' / ' +
                                (el.sizeLabel || '-')
                        }}</span>
                        <span *ngIf="el.colorLabel && !el.sizeLabel">{{
                            el.colorLabel
                        }}</span>
                        <span *ngIf="el.sizeLabel && !el.colorLabel">{{
                            el.sizeLabel
                        }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Quantity</th>
                    <td mat-cell *matCellDef="let el; index as i">
                        <div
                            *ngIf="variantGriddata.length > 0"
                            style="width: 65px"
                        >
                            <sp-custom-number-input
                                [value]="el.quantity"
                                (valueUpdateEvent)="
                                    updateQuantityToRow($event, i)
                                "
                            ></sp-custom-number-input>
                        </div>
                        <div
                            *ngIf="variantGriddata.length === 0"
                            style="width: 65px"
                        >
                            --
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let el; index as i">
                        <img
                            *ngIf="variantGriddata.length > 0"
                            src="assets/icons/delete.svg"
                            (click)="deleteSingleVariant(i)"
                        />
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns1"
                ></tr>
            </table>
        </div>
    </div>
</div>
